import { render, staticRenderFns } from "./user_info.vue?vue&type=template&id=3a3e1e56&scoped=true"
import script from "./user_info.vue?vue&type=script&lang=js"
export * from "./user_info.vue?vue&type=script&lang=js"
import style0 from "./user_info.vue?vue&type=style&index=0&id=3a3e1e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3e1e56",
  null
  
)

export default component.exports